export default __webpack_public_path__ + "static/tabs-grouping-dont-d1839455f6ade50b05008adf8669bf34.png";